import {asset} from 'imba';
import url from './blob1.svg';
export default asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"viewBox":"0 0 328 295","width":"328","height":"295","fill":"none"},"flags":[],"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152.5 0C221-1.3 295.8 17.3 319.2 81.6c25.5 70-6.5 148.2-67.8 190.4-56.8 39-131 25.3-186.1-16C13 216.7-14 150.2 7.3 88.4 27.4 29 89.8 1.4 152.4.1z\" fill=\"currentColor\"/>"},
	toString: function(){ return this.url;}
})